// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","OverlayedTextBackground":"_3TTChK","centerText":"_30Cp9i","OverlayedTextWrapper":"_1ur-H6","OverlayedTextTitle":"_226DCj","fadeInFrames":"_3Zr0oi"};